import { useEffect, useState } from "react";
import axios from "axios";
import { Activity } from "lucide-react";
import { useI18n } from "@/lib/i18n";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const COPY = {
  de: {
    aria: "Live-Aktivität",
    week: (n) => `Diese Woche in Mels · ${n} neue Anfragen bearbeitet`,
    finder: (n) => `Verfahren-Finder bisher ${n}× ausgeführt`,
    total: (n) => `Insgesamt ${n} Anfragen seit Online-Start`,
    hours: "Mo–Do 07:00–17:00 · Fr 07:00–16:00 · Mels SG",
    iso: "ISO 9001 · ISO 14001 · CO₂-reduzierte Prozesse",
  },
  en: {
    aria: "Live activity",
    week: (n) => `This week in Mels · ${n} new inquiries handled`,
    finder: (n) => `Process Finder run ${n}× to date`,
    total: (n) => `${n} inquiries since launch`,
    hours: "Mon–Thu 7am–5pm · Fri 7am–4pm · Mels SG",
    iso: "ISO 9001 · ISO 14001 · low-CO₂ processes",
  },
  fr: {
    aria: "Activité en direct",
    week: (n) => `Cette semaine à Mels · ${n} nouvelles demandes traitées`,
    finder: (n) => `Sélecteur de procédé utilisé ${n}× à ce jour`,
    total: (n) => `${n} demandes depuis le lancement`,
    hours: "Lun–Jeu 7h–17h · Ven 7h–16h · Mels SG",
    iso: "ISO 9001 · ISO 14001 · procédés à faible CO₂",
  },
  it: {
    aria: "Attività in tempo reale",
    week: (n) => `Questa settimana a Mels · ${n} nuove richieste evase`,
    finder: (n) => `Selettore procedimento eseguito ${n}× ad oggi`,
    total: (n) => `${n} richieste dal lancio online`,
    hours: "Lun–Gio 7:00–17:00 · Ven 7:00–16:00 · Mels SG",
    iso: "ISO 9001 · ISO 14001 · processi a CO₂ ridotto",
  },
};

export const ActivityStrip = () => {
  const [stats, setStats] = useState(null);
  const { lang } = useI18n();
  const c = COPY[lang] || COPY.de;

  useEffect(() => {
    let alive = true;
    axios
      .get(`${API}/public-stats`)
      .then(({ data }) => {
        if (alive) setStats(data);
      })
      .catch(() => {});
    return () => {
      alive = false;
    };
  }, []);

  if (!stats) return null;

  const items = [
    c.week(stats.this_week),
    c.finder(stats.verfahren_finder_total),
    c.total(stats.total_inquiries),
    c.hours,
    c.iso,
  ];
  const row = [...items, ...items];

  return (
    <section
      data-testid="activity-strip"
      className="relative bg-black border-y border-white/10 overflow-hidden"
      aria-label={c.aria}
    >
      <div className="flex w-max marquee-track items-center">
        {row.map((it, i) => (
          <div key={i} className="flex items-center gap-4 px-8 py-3 whitespace-nowrap">
            <Activity className="w-3.5 h-3.5 text-emerald-400 flex-none" strokeWidth={1.8} />
            <span className="text-[12px] uppercase tracking-[0.2em] text-zinc-300">
              {it}
            </span>
            <span className="text-zinc-700">·</span>
          </div>
        ))}
      </div>
    </section>
  );
};

export default ActivityStrip;
